import React, { useState } from 'react';
import { SubscriptionUpdatePaymentModal } from '@nexus/fff-payments';
import { useUserContext } from '@nexus/fff-utilities';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { trackEvent } from '@nexus/fff-analytics';

import Layout from '../../components/Layout';
import DesktopLayout from './DesktopLayout';
import MobileLayout from './MobileLayout';
import useScreenMode from '../../hooks/useScreenMode';
import { Plans, PlansLiteral } from '../constants';
import useLaunchDarkly from '../../hooks/useLaunchDarkly';
import useShowErrorOrRedirectThankYouPage from '../../hooks/useShowPayErrorOrThankYouPage';
import './styles.css';

const DESKTOP = 'desktop';

const TrialUpgrade = ({
  history, flags, ldClient, location: { pathname },
}) => {
  const [selected, setSelected] = useState(Plans.SEASONAL);
  const { userInfo } = useUserContext();
  useLaunchDarkly(ldClient, userInfo);
  const isTrial = userInfo && userInfo.user && userInfo.user.subscriptionType === 'TRIAL';
  const handleChange = (membership) => setSelected(membership);
  const screenMode = useScreenMode();
  const thanksPage = pathname && pathname.indexOf('/my-account-v3/') === -1
    ? '/trial-upgrade-thanks'
    : '/my-account-v3/trial-upgrade-thanks';

  const {
    showPayment,
    errorPaymentMessage,
    changeSubscription,
    onClose,
    isLoading,
  } = useShowErrorOrRedirectThankYouPage(history, thanksPage, Plans.TRIAL);

  if (!isTrial) {
    window.location.replace(process.env.REACT_APP_SITE_URL);
    return null;
  }

  const handleChangeSubscription = () => {
    trackEvent({
      ctaName: 'upgrade-confirmation',
      properties: { upgrading_plan: Plans.ANNUAL === selected ? PlansLiteral.ANNUAL : PlansLiteral.SEASONAL },
    });
    changeSubscription(selected);
  };

  const { displayAdditionalPerks } = flags;

  return (
    <Layout isLoading={isLoading}>
      {screenMode !== DESKTOP
        ? (
          <MobileLayout
            handleChange={handleChange}
            selected={selected}
            showAdditionalPerks={displayAdditionalPerks}
            onClickUpgrade={handleChangeSubscription}
          />
        )
        : (
          <DesktopLayout
            handleChangeActive={handleChange}
            active={selected}
            showAdditionalPerks={displayAdditionalPerks}
            onClickUpgrade={handleChangeSubscription}
          />
        )}

      <SubscriptionUpdatePaymentModal
        onClose={onClose}
        subtitle={errorPaymentMessage}
        isOpen={showPayment}
        onSuccess={handleChangeSubscription}
        hasError={!!errorPaymentMessage}
      />
    </Layout>
  );
};

export default withLDConsumer()(TrialUpgrade);
